<template>
	<section
		id="comment-form"
		class="comment-box lg:mb-[32px]"
	>
		<h5
			v-if="store.commentToReplyName"
			class="subtitle text-[24px] leading-none lg:leading-tight mb-[24px] font-semibold"
		>
			Replying to {{ commentToReplyNameRef }}
		</h5>

		<Heading
			v-else
			tag="h5"
			text="Leave a reply"
			class="mb-[24px] font-semibold"
		/>

		<div
			v-if="left_comment"
			ref="commentFeedback"
			class="comment-submit-message comment-succesful"
		>
			<h3
				v-if="store.commentToReplyName"
				class="text-xl font-semibold"
			>
				Reply to {{ store.commentToReplyName }} succesfully sent.
			</h3>
			<h3
				v-else
				class="text-xl font-semibold"
			>
				Thanks! Your comment has been submitted.
			</h3>

			<p class="text-base">Your comment should be available shortly.</p>
		</div>

		<textarea
			id=""
			ref="content"
			name="comment-body"
			rows="4"
			placeholder="Comment"
			class="form-input text-area mb-[16px]"
		/>

		<div
			v-if="errorMessage"
			class="comment-submit-message comment-error"
		>
			<p class="text-base">{{ errorMessage }}</p>
		</div>

		<div class="flex grid grid-cols-1 lg:grid-cols-3 gap-[16px]">
			<input
				ref="author_email"
				type="text"
				name="comment-email"
				placeholder="Email"
				class="form-input"
			/>
			<input
				ref="author_name"
				type="email"
				name="comment-name"
				placeholder="Name"
				class="form-input"
			/>
			<Button
				:label="submitting ? 'Posting...' : 'Post comment'"
				:on-click="postComment"
				:disabled="submitting"
			/>
		</div>
	</section>
</template>

<script setup>
import $axios from "axios";

const author_name = ref();
const author_email = ref();
const content = ref();
const commentFeedback = ref();
const left_comment = ref();
const submitting = ref(false);
const errorMessage = ref("");

const postComment = async (e) => {
	if (e?.preventDefault) e.preventDefault();

	if (submitting.value) return;

	// Don't send the request if the comment is empty
	if (!content.value?.value?.trim()) return;

	submitting.value = true;
	errorMessage.value = "";

	const body = {
		author_name: author_name.value.value,
		author_email: author_email.value.value,
		content: content.value.value,
		post: store.postId,
		parent: store.commentToReply
	};

	try {
		const response = await $axios.post("/api/comments", body);

		if (response.status === 201) {
			author_email.value.value = "";
			author_name.value.value = "";
			content.value.value = "";
		}

		left_comment.value = true;
		setTimeout(() => {
			commentFeedback.value.classList.add("fade-out");
			setTimeout(() => {
				commentFeedback.value.classList.remove("fade-out");
				left_comment.value = false;
				store.setCommentIdToReply({ id: null, commentToReplyName: null });
			}, 1000);
		}, 10000);
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error(err);
		errorMessage.value = "Something went wrong. Please try again.";
	} finally {
		submitting.value = false;
	}
};
</script>
<style lang="scss" scoped>
@import "@assets/utils.scss";

.comment-box {
	display: inline-block;
	width: 100%;
}

.form-input {
	padding: 8px 16px;
	border-radius: 8px;
	border: 1px solid $neutral-400;
	width: 100%;
	background: white;
	min-height: 44px;

	&::placeholder {
		color: $neutral-500;
		font-family: Rubik;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
	}

	&.text-area {
		padding: 16px 16px;
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
@keyframes fadeOut {
	0% {
		opacity: 1;
	}
	100% {
		opacity: 0;
	}
}

.comment-succesful {
	animation: fadeIn 1s;
	padding: 32px 24px;
	text-align: center;
	margin-bottom: 56px;
	border-radius: 12px;
	border: 1px solid #22c55e;
	background-color: #f0fdf4;
}
.comment-error {
	animation: fadeIn 0.3s;
	padding: 16px 24px;
	text-align: center;
	margin-bottom: 16px;
	border-radius: 12px;
	border: 1px solid #ef4444;
	background-color: #fef2f2;
	color: #991b1b;
}
.fade-out {
	animation: fadeOut 1s;
}
</style>
